import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MaterialModule } from './material-module';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';

import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyAzc-gL1cQQI6PxvU5PR9JKagZrnBoFQxs",
  authDomain: "top-crew.firebaseapp.com",
  databaseURL: "https://top-crew.firebaseio.com",
  projectId: "top-crew",
  storageBucket: "top-crew.appspot.com",
  messagingSenderId: "801821592786",
  appId: "1:801821592786:web:96b3cd4c21c5f570"
};


import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';

import { HomeComponent } from './home/home.component';

import { EligibilityComponent } from './eligibility/eligibility.component';
import { CoursesComponent } from './courses/courses.component';
import { FaqComponent } from './faq/faq.component';
import { TeamComponent } from './team/team.component';
import { ApplyComponent } from './apply/apply.component';



const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'eligibility', component: EligibilityComponent },

  { path: 'courses', component: CoursesComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'team', component: TeamComponent },
  { path: 'apply', component: ApplyComponent },

];



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FaqComponent,
    EligibilityComponent,
    FooterComponent,
    TeamComponent,
    CoursesComponent,
    ApplyComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule.forRoot(routes),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideFirestore(() => getFirestore()),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {

}
